<template>
<div class="page-container-wrapper">
  <loader v-if="dataLoading"/>
  <template v-else>
    <div class="page-container-header d-flex align-items-center">
        <h2 class="text-md mb-0">{{ $t('message.Guideline.publications') }}</h2>

        <b-button variant="info" class="mr-2 ml-auto" @click="goBack">{{ $t('message.return') }}</b-button>
    </div>

    <div class="container-fluid">
      <div class="row">
        <!-- LEFT -->
        <div class="col-md-12 col-xl-7">
          <div class="page-container guidelines-editor" id="page-container">
            <b-alert v-show="dataError" class="mt-4" show variant="danger">{{ $t('message.connectionError') }}</b-alert>
            <div class="padding">
              <template v-if="isGuidelineSubmitter && guideline.phase == guidelinePhases.uploadedForReview">
                <b-card :title="'Waiting for review.'" class="mb-2">
                  {{ $t('message.Guideline.waitingForReview') }}
                </b-card>
              </template>

              <template v-if="isGuidelineSubmitter && guideline.phase == guidelinePhases.uploadReviewed">
                <b-card :title="$t('message.Guideline.guidelineWasReviewed')" class="mb-2">
                  <router-link class="btn btn-primary btn text-center" :to="'/guidelines/' + guideline.id + '/upload'">
                    {{ $t('message.Guideline.uploadCorrectedFiles') }}
                  </router-link>
                </b-card>
              </template>

              <div class="row" v-if="canForwardToCommittee">
                <div class="col-md-12">
                  <b-card :title="$t('message.Guideline.sectionForwardToCommitteeReview')" class="mb-2">
                    {{ $t('message.Guideline.guidelineToCommittee') }}<br/>

                    <b-button v-if="haveReviewer" variant="success" @click="forwardToCommitteeInfo" class="mt-3 mr-3">
                      {{ $t('message.Guideline.toCommitteeReview') }}
                    </b-button >

                    <b-button variant="primary" @click="forwardToNationalDelegatesInfo" class="mt-3 mr-3">
                      {{ $t('message.Guideline.toNationalDelegates') }}
                    </b-button >

                    <b-button v-if="haveReviewer" variant="info" @click="forwardToParallelInfo" class="mt-3">
                      {{ $t('message.Guideline.toParallelReview') }}
                    </b-button >
                  </b-card>
                </div>
              </div>

              <div class="row" v-if="canForwardToNd">
                <div class="col-md-12">
                  <b-card :title="$t('message.Guideline.sectionForwardToNationalDelegates')" class="mb-2">
                    {{ $t('message.Guideline.guidelineToNationalDelegates') }}<br/>

                    <b-button variant="success" @click="forwardToNationalDelegatesInfo" class="mt-3 mr-3">
                      {{ $t('message.Guideline.forwardToNationalDelegates') }}
                    </b-button >

                    <b-button v-if="guideline.can_skip_nd_review" variant="warning" @click="skipNdReviewInfo" class="mt-3">
                      {{ $t('message.Guideline.skipNdReview') }}
                    </b-button >
                  </b-card>
                </div>
              </div>

              <div class="row" v-if="canDecideParallel">
                <div class="col-md-12">
                  <b-card :title="$t('message.Guideline.sectionParallelReviewDecision')" class="mb-2">
                    {{ $t('message.Guideline.guidelineParallelDecision') }}<br/>

                    <b-button variant="success" @click="parallelProceedInfo" class="mt-3 mr-3">
                      {{ $t('message.Guideline.parallelProceed') }}
                    </b-button >

                    <b-button v-if="haveReviewer" variant="primary" @click="forwardToCommitteeInfo" class="mt-3 mr-3">
                      {{ $t('message.Guideline.toCommitteeReview') }}
                    </b-button >

                    <b-button variant="primary" @click="forwardToNationalDelegatesInfo" class="mt-3 mr-3">
                      {{ $t('message.Guideline.toNationalDelegates') }}
                    </b-button >

                    <b-button v-if="haveReviewer" variant="info" @click="parallelAnotherRoundInfo" class="mt-3">
                      {{ $t('message.Guideline.parallelAnotherRound') }}
                    </b-button >
                  </b-card>
                </div>
              </div>


              <div class="row">
                <div class="col-md-12">
                  <b-card v-if="allowSectionNationalDelegatesReview(guideline.phase) && myReview().length == 0"
                          :title="$t('message.Guideline.sectionNationalDelegatesReview')" class="mb-2 fileUploader">

                      <b-form-group>
                        <b-form-radio-group v-model="changeType">
                          <b-form-radio value="0">{{ $t('message.Guideline.nationalDelegatesReview.looksGood') }}
                          </b-form-radio>
                          <b-form-radio value="1">{{ $t('message.Guideline.nationalDelegatesReview.minor') }}</b-form-radio>
                          <b-form-radio value="2">{{ $t('message.Guideline.nationalDelegatesReview.major') }}</b-form-radio>
                        </b-form-radio-group>
                      </b-form-group>

                      <template v-if="changeType > 0">
                        <b-form-textarea
                                v-model="comment"
                                class="mb-4"
                                :placeholder="$t('message.Guideline.reviewerComment')"
                                :rows="4"
                                :max-rows="6"
                        >
                        </b-form-textarea>
                      </template>
                      <template v-else-if="changeType == 0">
                        {{ $t("message.Guideline.ndLooksGood") }}
                      </template>

                      <b-button :disabled="changeType == null" class="float-right mr-2" variant="success"
                                @click="submitNationalDelegateReviewInfo">
                        {{ $t("message.Guideline.submitNationalDelegateReview") }}
                      </b-button>

                  </b-card>
                </div>
              </div>

              <div class="row">
                <div class="col-md-12">
                  <b-card v-if="showSubmitterUploadForm" :title="$t('message.Guideline.sectionReuploadFiles')" class="mb-2 fileUploader">
                    <router-link class="btn btn-primary text-center" :to="'/guidelines/' + guideline.id + '/upload'">
                      {{ $t('message.Guideline.uploadCorrectedFiles') }}
                    </router-link>
                  </b-card>

                  <!-- LEFT BASE DATA -->
                  <base-data-left :guideline="guideline" class="d-xl-none"></base-data-left>

                  <!-- LEFT PROGRESS -->
                  <phase-preview-left :guideline="guideline" class="d-xl-none"></phase-preview-left>

                  <b-card :title="$t('message.Guideline.sectionUploadedFiles')" class="mb-2 fileUploader">
                    <template v-if="filesUploaded && filesUploaded.length">
                      <div class="table-responsive">
                        <b-table striped hover :items="filesUploaded" :fields="['size', {key: 'upload_id', label: $t('message.Guideline.uploadId')}, {key: 'name', label: $t('message.Guideline.file')}, 'type', 'actions']">
                          <template slot="info" slot-scope="data">
                            <pre>
                              {{ data.item.response.data.id  }}
                            </pre>
                          </template>

                          <template slot="upload_id" slot-scope="data">
                            {{ $t("message.Guideline.fileVersion", {version: data.item.upload_id}) }}
                          </template>

                          <template slot="progress" slot-scope="data">
                            <b-progress :value="parseInt(data.item.progress)" :max="100" show-progress animated></b-progress>
                          </template>

                          <template slot="actions" slot-scope="data">
                            <a target="_blank" :href="data.item.url">
                              <font-awesome-icon icon="download" size="lg" class="mr-2"/>
                            </a>

                            <a v-if="isSuperUser && showSubmitterUploadForm" @click.prevent="deleteFileInfo(data.item)">
                              <font-awesome-icon icon="trash" size="lg" class="mr-2 text-danger"/>
                            </a>

                          </template>
                        </b-table>
                      </div>
                    </template>

                    <button class="btn btn-outline-secondary" @click="getZipped">
                      {{ $t('message.Guideline.downloadZipped') }}
                    </button >
                  </b-card>

                </div>
              </div>

              <b-card title="On Hold Comments" v-if="onHoldComments && onHoldComments.length > 0">

                  <b-table striped hover :items="onHoldComments" :fields="['user_name','type', 'comment']">
                    <template slot="type" slot-scope="data">
                      <template v-if="data.item.type == 1">
                        by GPC
                      </template>
                      <template v-else-if="data.item.type == 2">
                        by IGO
                      </template>
                    </template>
                  </b-table>

              </b-card>

              <b-card title="Committee reviews" v-if="canDecideParallel && committeeReviews && committeeReviews.length > 0">

                  <b-table striped hover :items="committeeReviews" :fields="['user_name', 'change_type', 'comment']">
                    <template slot="change_type" slot-scope="data">
                      {{ $t('message.Guideline.reviewType.change' + data.item.change_type) }}
                    </template>

                    <template slot="comment" slot-scope="data">
                      <template v-if="data.item.change_type == 0">
                        {{ $t('message.Guideline.noCommentEverythingok') }}
                      </template>
                      <template v-else>
                        <span class="preLine">{{ data.item.comment }}</span>
                      </template>
                    </template>
                  </b-table>

              </b-card>

              <b-card title="National delegates reviews" v-if="ndReviews && ndReviews.length > 0">

                  <b-table striped hover :items="ndReviews" :fields="['user_name', 'change_type', 'comment']">
                    <template slot="comment" slot-scope="data">
                      <template v-if="data.item.change_type == 0">
                        {{ $t('message.Guideline.noCommentEverythingok') }}
                      </template>
                      <template v-else>
                        <span class="preLine">{{ data.item.comment }}</span>
                      </template>
                    </template>

                    <template slot="change_type" slot-scope="data">
                      <template v-if="data.item.change_type == 0">
                        <b-row class="mt-3 px-3">
                          <b-col sm="12">
                        {{ $t('message.Guideline.nationalDelegatesReview.looksGood') }}
                          </b-col>
                        </b-row>
                      </template>
                      <template v-else-if="data.item.change_type == 1">
                        {{ $t('message.Guideline.nationalDelegatesReview.minor') }}
                      </template>
                      <template v-else>
                        {{ $t('message.Guideline.nationalDelegatesReview.major') }}
                      </template>
                    </template>
                  </b-table>

              </b-card>
            </div>
          </div>
        </div>

        <!-- RIGHT -->
        <div class="d-md-none d-xl-block col-xl-5">
          <base-data-right :guideline="guideline"></base-data-right>

          <phase-preview :guideline="guideline"></phase-preview>
        </div>
      </div>
    </div>

  </template>
</div>
</template>

<script>
import {
  GUIDELINE_REQUEST_BY_ID,
  GUIDELINE_CHANGE_PHASE,
  GUIDELINE_SUBMIT_NATIONAL_DELEGATE_REVIEW,
  GUIDELINE_DELETE_FILE_BY_ID
} from '@/store/actions/guidelines';

import { Guideline, GuidelinePhases } from '@/lib/guideline.js';

import BaseDataRight from '@/components/Guideline/BaseData/right.vue'
import BaseDataLeft from '@/components/Guideline/BaseData/left.vue'

import PhasePreview from '@/components/Guideline/PhasePreview'
import PhasePreviewLeft from '@/components/Guideline/PhasePreview/left.vue'

export default {
  name: 'guideline-on-hold',
  components: {
    BaseDataRight,
    BaseDataLeft,
    PhasePreview,
    PhasePreviewLeft,
  },
  props: [],
  data () {
    return {
      guideline: new Guideline,
      guidelinePhases: GuidelinePhases,
      changeType: null,
      comment: '',
    }
  },
  computed: {
    isGuidelineSubmitter() {
      return this.getUserData.id == this.guideline.submitter_id;
    },

    filesUploaded() {
      if (this.guideline && this.guideline.files) {
        return this.guideline.files.filter(elem => { return elem.upload_id != null &&
          elem.upload_id == this.guideline.upload_id &&
          elem.user_id == this.guideline.submitter_id;
        });
      }

      return [];
    },

    ndReviews() {
      if (this.guideline && this.guideline.reviews) {
        return this.guideline.reviews.filter(elem => {return elem.user_type == 1});
      }
    },

    committeeReviews() {
      if (this.guideline && this.guideline.reviews) {
        return this.guideline.reviews.filter(elem => {return elem.user_type == 0});
      }
    },

    onHoldComments() {
      if (this.guideline && this.guideline.comments) {
        return this.guideline.comments.filter(elem => {return elem.type > 0});
      }
    },

    myReviews() {
      return this.guideline.reviews.filter(elem => {
        return elem.user_type == 1 && elem.user_id == this.getUserData.id
      });
    },

    allowReview() {
      if (this.guideline && this.guideline.reviews) {
        let crev = this.guideline.reviews.filter(elem => {
          return elem.user_type == 1 &&
            elem.upload_id == this.guideline.upload_id &&
            elem.user_id == this.getUserData.id
        });

        return crev.length == 0;
      }

      return false;
    },

    haveReviewer() {
      return this.guideline.review_user_ids.length > 0;
    },

    canForwardToCommittee() {
      return (this.guideline.phase === this.guidelinePhases.uploadGpcReviewedEnd) && this.isSuperUser;
    },

    canForwardToNd() {
      return (this.guideline.phase === this.guidelinePhases.uploadReviewedEnd) && this.isSuperUser;
    },

    canDecideParallel() {
      return (this.guideline.phase === this.guidelinePhases.parallelReviewEnd) && this.isSuperUser;
    },

    showSubmitterUploadForm() {
      if (this.guideline.phase == this.guidelinePhases.reviewedByNationalDelegates || this.guideline.phase == this.guidelinePhases.gpcFinalHold || this.guideline.phase == this.guidelinePhases.boardApprovalOnHold) {
        return this.isGuidelineSubmitter;
      }
    }
  },
  mounted () {
    this.getData();
  },
  methods: {
    getData() {
      this.$store.dispatch(GUIDELINE_REQUEST_BY_ID, this.$route.params.id).then((response) => {
        if (response.data.data.phase < this.guidelinePhases.uploadReviewedEnd) {
          if(response.data.data.phase !== this.guidelinePhases.uploadGpcReviewedEnd &&
             response.data.data.phase !== this.guidelinePhases.parallelReview &&
             response.data.data.phase !== this.guidelinePhases.parallelReviewEnd){
           this.$router.push('/guidelines/' + response.data.data.id + '/view')
          }
        }

        this.guideline = response.data.data;

        this.files = this.guideline.files.filter(elem => (elem.user_id == this.getUserData.id && elem.upload_id == null));

      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },

    goBack() {
      this.$router.push('/guidelines/')
    },

    getZipped() {
      window.open(this.guideline.zipUrl);
    },

    deleteFileInfo(file, fileIndex) {
      let fileId = file.response != undefined ? file.response.data.id : file.id;

      this.$swal({
        title: this.$t('message.areYouSure'),
        html: this.$t('message.Guideline.deleteFileInfo'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('message.yesImSure'),
        cancelButtonText: this.$t('message.noCancel'),
      }).then((result) => {
        if (result.value != undefined) {
          this.deleteFile(fileId, fileIndex);
        }
      });
    },

    deleteFile(fileId) {
      this.$store.dispatch(GUIDELINE_DELETE_FILE_BY_ID, {gid: this.guideline.id, fid: fileId})
      .then(() => {
        this.getData();
      }).catch((error) => {
        this.handleUnauth(error.response.status);
      });
    },

    allowSectionForwardToNationalDelegates(phase) {
      return this.isSuperUser && (phase == this.guidelinePhases.uploadReviewedEnd);
    },

    allowSectionNationalDelegatesReview(phase) {
      /**
       * Check that user reviewd already
       */
      return this.isNationalDelegate &&
        [this.guidelinePhases.reviewByNationalDelegates, this.guidelinePhases.parallelReview].indexOf(phase) !== -1;
    },

    myReview() {
      if (this.guideline && this.guideline.reviews) {
        return this.guideline.reviews.filter(elem => {
          return elem.user_id == this.getUserData.id && elem.upload_id == this.guideline.upload_id
        });
      }
    },

    forwardToCommitteeInfo() {
      this.$swal({
        title: this.$t('message.areYouSure'),
        html: this.$t('message.Guideline.forwardToCommitteeInfo'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('message.yesImSure'),
        cancelButtonText: this.$t('message.noCancel'),
      }).then((result) => {
        if (result.value != undefined) {
          this.forwardToCommittee();
        }
      });
    },

    forwardToParallelInfo() {
      this.$swal({
        title: this.$t('message.areYouSure'),
        html: this.$t('message.Guideline.forwardToParallelReviewInfo'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('message.yesImSure'),
        cancelButtonText: this.$t('message.noCancel'),
      }).then((result) => {
        if (result.value != undefined) {
          this.forwardToParallel();
        }
      });
    },

    forwardToNationalDelegatesInfo() {
      this.$swal({
        title: this.$t('message.areYouSure'),
        html: this.$t('message.Guideline.forwardToNationalDelegatesInfo'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('message.yesImSure'),
        cancelButtonText: this.$t('message.noCancel'),
      }).then((result) => {
        if (result.value != undefined) {
          this.forwardToNationalDelegates();
        }
      });
    },

    forwardToCommittee() {
      this.$store.dispatch(GUIDELINE_CHANGE_PHASE, {id:this.guideline.id, phase: this.guidelinePhases.uploadedForReview})
        .then(() => {
          this.$swal({
            title: this.$t("message.success"),
            text: this.$t("message.Guideline.successfullyForwardToCommittee"),
            type: 'success',
            confirmButtonText: 'OK'
          });
          this.getData();
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },

    forwardToParallel() {
      this.$store.dispatch(GUIDELINE_CHANGE_PHASE, {id:this.guideline.id, phase: this.guidelinePhases.parallelReview})
        .then(() => {
          this.$swal({
            title: this.$t("message.success"),
            text: this.$t("message.Guideline.successfullyForwardToParallel"),
            type: 'success',
            confirmButtonText: 'OK'
          });
          this.getData();
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },

    parallelProceedInfo() {
      this.$swal({
        title: this.$t('message.areYouSure'),
        html: this.$t('message.Guideline.parallelProceedInfo'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('message.yesImSure'),
        cancelButtonText: this.$t('message.noCancel'),
      }).then((result) => {
        if (result.value != undefined) {
          this.parallelProceed();
        }
      });
    },

    parallelProceed() {
      this.$store.dispatch(GUIDELINE_CHANGE_PHASE, {id:this.guideline.id, phase: this.guidelinePhases.reviewByNationalDelegatesEnd})
        .then(() => {
          this.$swal({
            title: this.$t("message.success"),
            text: this.$t("message.Guideline.successfullyParallelProceed"),
            type: 'success',
            confirmButtonText: 'OK'
          });
          this.getData();
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },

    parallelAnotherRoundInfo() {
      this.$swal({
        title: this.$t('message.areYouSure'),
        html: this.$t('message.Guideline.parallelAnotherRoundInfo'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('message.yesImSure'),
        cancelButtonText: this.$t('message.noCancel'),
      }).then((result) => {
        if (result.value != undefined) {
          this.parallelAnotherRound();
        }
      });
    },

    parallelAnotherRound() {
      this.$store.dispatch(GUIDELINE_CHANGE_PHASE, {id:this.guideline.id, phase: this.guidelinePhases.parallelReview})
        .then(() => {
          this.$swal({
            title: this.$t("message.success"),
            text: this.$t("message.Guideline.successfullyParallelAnotherRound"),
            type: 'success',
            confirmButtonText: 'OK'
          });
          this.getData();
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },

    forwardToNationalDelegates() {
      this.$store.dispatch(GUIDELINE_CHANGE_PHASE, {id:this.guideline.id, phase: this.guidelinePhases.reviewByNationalDelegates})
        .then(() => {
          this.$swal({
            title: this.$t("message.success"),
            text: this.$t("message.Guideline.successfullyForward"),
            type: 'success',
            confirmButtonText: 'OK'
          });
          this.getData();
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },

    skipNdReviewInfo() {
      this.$swal({
        title: this.$t('message.areYouSure'),
        html: this.$t('message.Guideline.skipNdReviewInfo'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('message.yesImSure'),
        cancelButtonText: this.$t('message.noCancel'),
      }).then((result) => {
        if (result.value != undefined) {
          this.skipNdReview();
        }
      });
    },

    skipNdReview() {
      this.$store.dispatch(GUIDELINE_CHANGE_PHASE, {id:this.guideline.id, phase: this.guidelinePhases.reviewByNationalDelegatesEnd})
        .then(() => {
          this.$swal({
            title: this.$t("message.success"),
            text: this.$t("message.Guideline.successfullySkipNdReview"),
            type: 'success',
            confirmButtonText: 'OK'
          });
          this.getData();
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },


    submitNationalDelegateReviewInfo() {
      this.$swal({
        title: this.$t('message.areYouSure'),
        html: this.$t('message.Guideline.submitNationalDelegateReviewInfo'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('message.yesImSure'),
        cancelButtonText: this.$t('message.noCancel'),
      }).then((result) => {
        if (result.value != undefined) {
          this.submitNationalDelegateReview();
        }
      });
    },

    submitNationalDelegateReview() {
      this.$store.dispatch(GUIDELINE_SUBMIT_NATIONAL_DELEGATE_REVIEW, {id:this.guideline.id, changeType: this.changeType, comment: this.comment})
        .then(() => {
          this.$swal({
            title: this.$t("message.success"),
            text: this.$t("message.Guideline.successfullyNDReviewed"),
            type: 'success',
            confirmButtonText: 'OK'
          });
          this.getData();
      }).catch((error) => {
        this.handleUnauth(error.response.status);
        this.handleForbidden(error.response.status);
      });
    },
  }
}
</script>

<style scoped lang="scss">

</style>

